// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Button,
//   Paper,
//   IconButton,
//   CircularProgress,
//   Alert,
//   Tooltip,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Stack,
//   Avatar,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   alpha,
// } from '@mui/material';
// import {
//   ArrowBack as ArrowBackIcon,
//   Edit as EditIcon,
//   Business as BusinessIcon,
//   Person as PersonIcon,
//   Description as DescriptionIcon,
//   PriorityHigh as PriorityHighIcon,
//   LocalPhone as PhoneIcon,
//   LocationOn as LocationIcon,
//   Inventory as InventoryIcon,
//   Launch as LaunchIcon,
//   CalendarToday as CalendarIcon,
//   History as HistoryIcon,
//   SyncAlt as SyncAltIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Assignment as AssignmentIcon,
//   Schedule as ScheduleIcon,
//   Source as SourceIcon,
//   Notes as NotesIcon,
//   Tag as TagIcon,
// } from '@mui/icons-material';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import { format } from 'date-fns';
// import Brandcrumb from '../../../../componentsUiBlock/Brandcrumb';
// import { request } from '../../../../utils/request';
// import { ApiResponseSingleEnquiry, Employee, Enquiry, Party, Product, StatusActivity } from '../../types';
// import { toast } from 'react-toastify';
// import { getStatusIconBall } from '../ListEnquiry';

// const ShowEnquiry = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [enquiry, setEnquiry] = useState<Enquiry | null>(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [party, setParty] = useState<Party | null>(null);
//   const [employee, setEmployee] = useState<Employee | null>(null);
//   const [products, setProducts] = useState<Product[]>([]);
//   const [statusHistory, setStatusHistory] = useState<StatusActivity[]>([]);

//   // Status change dialog
//   const [statusDialogOpen, setStatusDialogOpen] = useState(false);
//   const [newStatus, setNewStatus] = useState<string>('');
//   const [statusNote, setStatusNote] = useState<string>('');
//   const [changingStatus, setChangingStatus] = useState(false);



//   const fetchEnquiry = useCallback(async () => {
//     if (!id) return;

//     setLoading(true);
//     try {
//       const response = await request({
//         url: `enquiry/get-single-enquiry/${id}`,
//         method: 'get',
//       }) as ApiResponseSingleEnquiry;

//       if (response.success && response.data) {
//         const enquiryData = response.data;
//         setEnquiry(enquiryData);
//         setParty(enquiryData.party || null);
//         setEmployee(enquiryData.assigned_employee || null);
//         setProducts(enquiryData.products || []);

//         // Set status history
//         let history = enquiryData.status_history || [];
//         if (history.length === 0 && enquiryData.status) {
//           history = [{
//             from_status: undefined,
//             to_status: enquiryData.status,
//             note: enquiryData.status_note || '',
//             changed_at: enquiryData.status_changed_at || enquiryData.created_at || new Date(),
//             is_initial: true,
//             created_at: undefined
//           }];
//         }
//         setStatusHistory(history);
//       } else {
//         setError('Enquiry not found');
//       }
//     } catch (err: any) {
//       console.error('Error fetching enquiry:', err);
//       setError(err.message || 'Failed to load enquiry details');
//     } finally {
//       setLoading(false);
//     }
//   }, [id]);

//   useEffect(() => {
//     fetchEnquiry();
//   }, [fetchEnquiry]);

//   const getStatusColor = (status?: string) => {
//     switch (status) {
//       case 'NEW': return 'success';
//       case 'ASSIGNED': return 'info';
//       case 'IN_PROGRESS': return 'primary';
//       case 'FOLLOW_UP': return 'warning';
//       case 'CONVERTED': return 'secondary';
//       case 'CLOSED': return 'default';
//       case 'CANCELLED': return 'error';
//       default: return 'default';
//     }
//   };

//   const getStatusIcon = (status?: string) => {
//     switch (status) {
//       case 'NEW': return <CheckCircleIcon fontSize="small" />;
//       case 'ASSIGNED': return <AssignmentIcon fontSize="small" />;
//       case 'IN_PROGRESS': return <SyncAltIcon fontSize="small" />;
//       case 'FOLLOW_UP': return <ScheduleIcon fontSize="small" />;
//       case 'CONVERTED': return <CheckCircleIcon fontSize="small" />;
//       case 'CLOSED': return <CheckCircleIcon fontSize="small" />;
//       case 'CANCELLED': return <CancelIcon fontSize="small" />;
//       default: return <CheckCircleIcon fontSize="small" />;
//     }
//   };

//   const getPriorityIcon = (priority?: string) => {
//     switch (priority) {
//       case 'HIGH': return <PriorityHighIcon color="error" fontSize="small" />;
//       case 'MEDIUM': return <PriorityHighIcon color="warning" fontSize="small" />;
//       case 'LOW': return <PriorityHighIcon color="success" fontSize="small" />;
//       default: return <PriorityHighIcon color="disabled" fontSize="small" />;
//     }
//   };

//   const formatDateTime = (date: any) => {
//     if (!date) return 'N/A';
//     try {
//       return format(new Date(date), 'dd MMM yyyy, HH:mm');
//     } catch {
//       return 'Invalid date';
//     }
//   };

//   const formatDate = (date: any) => {
//     if (!date) return 'N/A';
//     try {
//       return format(new Date(date), 'dd/MM/yyyy');
//     } catch {
//       return 'Invalid date';
//     }
//   };

//   const handleStatusChange = async () => {
//     if (!newStatus || !enquiry || newStatus === enquiry.status) return;

//     setChangingStatus(true);
//     try {
//       const payload: any = {
//         status: newStatus,
//         status_note: statusNote.trim()
//       };

//       // Add status-specific fields if needed
//       if (newStatus === 'CLOSED') {
//         if (!enquiry.closed_result && !statusNote.trim()) {
//           toast.error('Please provide a closing reason');
//           setChangingStatus(false);
//           return;
//         }
//         payload.closed_result = statusNote.trim() || enquiry.closed_result || 'No reason provided';
//       } else if (newStatus === 'CANCELLED') {
//         if (!enquiry.cancelled_reason && !statusNote.trim()) {
//           toast.error('Please provide a cancellation reason');
//           setChangingStatus(false);
//           return;
//         }
//         payload.cancelled_reason = statusNote.trim() || enquiry.cancelled_reason || 'No reason provided';
//       }

//       const res = await request({
//         url: `enquiry/update-enquiry/${id}`,
//         method: 'put',
//         data: payload,
//       });

//       if (res.success) {
//         toast.success('Status updated successfully!');
//         setStatusDialogOpen(false);
//         setNewStatus('');
//         setStatusNote('');
//         fetchEnquiry(); // Refresh the data
//       } else {
//         toast.error(res.message || 'Failed to update status');
//       }
//     } catch (err: any) {
//       console.error('Status change error:', err);
//       toast.error(err || 'Failed to update status');
//     } finally {
//       setChangingStatus(false);
//     }
//   };

//   const openStatusDialog = () => {
//     if (enquiry) {
//       setNewStatus(enquiry.status ?? '');
//       setStatusNote('');
//       setStatusDialogOpen(true);
//     }
//   };

//   // Get activity timeline
//   const getActivityTimeline = () => {
//     const timeline = [...statusHistory];

//     // Sort by date (newest first)
//     timeline.sort((a, b) => {
//       const dateA = new Date(a.changed_at || 0);
//       const dateB = new Date(b.changed_at || 0);
//       return dateB.getTime() - dateA.getTime();
//     });

//     return timeline;
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
//         <CircularProgress size={24} />
//         <Typography variant="body2" sx={{ ml: 2, color: 'text.secondary' }}>
//           Loading enquiry details...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error || !enquiry) {
//     return (
//       <Box sx={{ p: 2 }}>
//         <Box sx={{ mb: 2, display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
//           <Brandcrumb />
//         </Box>
//         <Card>
//           <CardContent>
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {error || 'Enquiry not found'}
//             </Alert>
//             <Button
//               variant="outlined"
//               startIcon={<ArrowBackIcon />}
//               onClick={() => navigate('/enquiry')}
//               size="small"
//             >
//               Back to Enquiries
//             </Button>
//           </CardContent>
//         </Card>
//       </Box>
//     );
//   }

//   const activityTimeline = getActivityTimeline();

//   return (
//     <>
//       <Box sx={{ mb: 2, display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
//         <Brandcrumb />
//         <Chip
//           onClick={() => navigate(-1)}
//           icon={<ArrowBackIosNewIcon sx={{ fontSize: "14px" }} />}
//           label="Back"
//           variant="filled"
//           color="secondary"
//           sx={{
//             fontSize: '14px',
//             color: 'text.secondary',
//             cursor: 'pointer',
//             '&:hover': {
//               backgroundColor: 'action.hover'
//             }
//           }}
//         />
//       </Box>

//       <Box sx={{ mb: 3 }}>
//         {/* Header */}
//         <Box sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 2,
//           p: 2,
//           backgroundColor: 'white',
//           borderRadius: 1,
//           border: '1px solid',
//           borderColor: 'divider',
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//             <IconButton
//               onClick={() => navigate('/enquiry')}
//               size="small"
//               sx={{ color: 'text.primary' }}
//             >
//               <ArrowBackIcon />
//             </IconButton>
//             <Box>
//               <Typography variant="h6" fontWeight="bold">
//                 {enquiry.subject}
//               </Typography>
//               {/* <Typography variant="h6" fontWeight="bold">
//                 {enquiry.enquiry_no}
//               </Typography> */}
//               <Typography variant="caption" color="text.secondary">
//                 {/* {formatDate(enquiry.enquiry_date)} */}
//                 {enquiry.enquiry_no}
//               </Typography>
//             </Box>
//           </Box>

//           <Box sx={{ display: 'flex', gap: 1 }}>
//             <Tooltip title="Edit Enquiry" placement='top' arrow>
//               <IconButton
//                 size="small"
//                 color="primary"
//                 onClick={() => navigate(`/enquiry/editEnquiry/${id}`)}
//               >
//                 <EditIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         </Box>

//         {/* Two Column Layout with Equal Width */}
//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 2 }}>

//           {/* LEFT COLUMN */}
//           <Box sx={{ flex: 1 }}>
//             {/* Top Row: Assigned Date on Left, Status on Right */}
//             <Box sx={{ display: 'flex', mb: 1, gap: 1 }}>
//               {/* Assigned Date Card */}
//               <Card elevation={0} sx={{
//                 flex: 1,
//                 borderRadius: 1,
//                 border: '1px solid',
//                 borderColor: 'divider',
//                 display: 'flex',
//                 alignItems: 'center',
//                 p: 2,
//                 py:1
//               }}>
//                 <CalendarIcon fontSize="small" color="action" sx={{ mr: 1.5 }} />
//                 <Box>
//                   <Typography variant="caption" color="text.secondary" display="block">
//                     Assigned Date
//                   </Typography>
//                   <Typography variant="body2" fontWeight="medium">
//                     {enquiry.assigned_date ? formatDate(enquiry.assigned_date) : 'Not assigned'}
//                   </Typography>
//                 </Box>
//               </Card>

//               {/* Status Card with Change Button */}
//               <Card elevation={0} sx={{
//                 flex: 1,
//                 borderRadius: 1,
//                 border: '1px solid',
//                 borderColor: 'divider',
//                 p: 2,
//                 py:1,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between'
//               }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   {getStatusIcon(enquiry.status)}
//                   <Box sx={{ ml: 1.5 }}>
//                     <Stack direction={'row'} spacing={6}>
//                       <Typography variant="caption" color="text.secondary" display="block">
//                         Current Status
//                       </Typography>

//                       {/* <Button
//                         variant="outlined"
//                         size="small"
//                         // startIcon={<SyncAltIcon />}
//                         onClick={openStatusDialog}
//                         sx={{ fontSize: '0.5rem', borderColor: "black", color: "black" }}
//                       >
//                         Update Status
//                       </Button> */}
//                     </Stack>


//                     <Stack direction={'row'} spacing={.5} alignItems={"center"}>
//                       <Chip
//                         label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                           {getStatusIconBall(enquiry.status)}
//                           <Typography variant="caption" sx={{ fontWeight: 500 }}>
//                             {enquiry.status}
//                           </Typography>
//                         </Box>}
//                         color={getStatusColor(enquiry.status) as any}
//                         size="small"
//                         sx={{ height: 22, fontSize: '0.75rem', mt: 0.5 }}
//                       />
//                       <Tooltip title="Update Status" arrow placement='top'>
//                         <IconButton size="small" color="primary" onClick={openStatusDialog}>
//                           <SyncAltIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </Stack>

//                   </Box>
//                 </Box>

//               </Card>
//             </Box>

//             {/* Second Row: Priority on Left, Source on Right */}
//             <Box sx={{ display: 'flex', mb: 1, gap: 1 }}>
//               {/* Priority Card */}
//               <Card elevation={0} sx={{
//                 flex: 1,
//                 borderRadius: 1,
//                 border: '1px solid',
//                 borderColor: 'divider',
//                 display: 'flex',
//                 alignItems: 'center',
//                 p: 2,
//                 py:1
//               }}>
//                 {getPriorityIcon(enquiry.priority)}
//                 <Box sx={{ ml: 1.5 }}>
//                   <Typography variant="caption" color="text.secondary" display="block">
//                     Priority
//                   </Typography>
//                   <Typography variant="body2" fontWeight="medium">
//                     {enquiry.priority}
//                   </Typography>
//                 </Box>
//               </Card>

//               {/* Source Card */}
//               <Card elevation={0} sx={{
//                 flex: 1,
//                 borderRadius: 1,
//                 border: '1px solid',
//                 borderColor: 'divider',
//                 display: 'flex',
//                 alignItems: 'center',
//                 p: 2,
//                 py:1
//               }}>
//                 <SourceIcon fontSize="small" color="action" sx={{ mr: 1.5 }} />
//                 <Box>
//                   <Typography variant="caption" color="text.secondary" display="block">
//                     Source
//                   </Typography>
//                   <Typography variant="body2" fontWeight="medium">
//                     {enquiry.source}
//                   </Typography>
//                 </Box>
//               </Card>
//             </Box>

//             {/* Subject Section */}
//             <Card elevation={0} sx={{
//               borderRadius: 1,
//               mb: 1,
//               border: '1px solid',
//               borderColor: 'divider',
//               p: 2
//             }}>
//               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <DescriptionIcon fontSize="small" />
//                 Subject
//               </Typography>
//               <Typography variant="body1" fontWeight="medium">
//                 {enquiry.subject}
//               </Typography>
//             </Card>

//             {/* Description Section */}
//             <Card elevation={0} sx={{
//               borderRadius: 1,
//               mb: 1,
//               border: '1px solid',
//               borderColor: 'divider',
//               p: 2
//             }}>
//               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <NotesIcon fontSize="small" />
//                 Description
//               </Typography>
//               <Typography variant="body2" sx={{ whiteSpace: 'pre-line', fontSize: '0.9rem' }}>
//                 {enquiry.description}
//               </Typography>
//             </Card>

//             {/* Status-specific information */}
//             {(enquiry.status === 'CLOSED' && enquiry.closed_result) && (
//               <Card elevation={0} sx={{
//                 borderRadius: 1,
//                 mb: 1,
//                 border: '1px solid',
//                 borderColor: 'divider',
//                 p: 2,
//                 bgcolor: alpha('#4caf50', 0.08)
//               }}>
//                 <Typography variant="subtitle2" fontWeight="bold" color="success.main" sx={{ mb: 1 }}>
//                   Closed Result
//                 </Typography>
//                 <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
//                   {enquiry.closed_result}
//                 </Typography>
//               </Card>
//             )}

//             {(enquiry.status === 'CANCELLED' && enquiry.cancelled_reason) && (
//               <Card elevation={0} sx={{
//                 borderRadius: 1,
//                 mb: 1,
//                 border: '1px solid',
//                 borderColor: 'divider',
//                 p: 2,
//                 bgcolor: alpha('#f44336', 0.08)
//               }}>
//                 <Typography variant="subtitle2" fontWeight="bold" color="error.main" sx={{ mb: 1 }}>
//                   Cancellation Reason
//                 </Typography>
//                 <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
//                   {enquiry.cancelled_reason}
//                 </Typography>
//               </Card>
//             )}

//             {/* Activity Timeline */}
//             <Card elevation={0} sx={{
//               borderRadius: 1,
//               border: '1px solid',
//               borderColor: 'divider',
//               p: 2
//             }}>
//               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <HistoryIcon fontSize="small" />
//                 Activity Timeline
//               </Typography>

//               {activityTimeline.length > 0 ? (
//                 <List sx={{
//                   position: 'relative',
//                   '&:before': {
//                     content: '""',
//                     position: 'absolute',
//                     left: 12,
//                     top: 5,
//                     bottom: 0,
//                     width: 2,
//                     backgroundColor: 'divider'
//                   },
//                   py: 0
//                 }}>
//                   {activityTimeline.map((activity, index) => (
//                     <ListItem
//                       key={index}
//                       sx={{
//                         position: 'relative',
//                         alignItems: 'flex-start',
//                         py: 1.5,
//                         px: 0,
//                         '&:last-child': {
//                           pb: 0
//                         }
//                       }}
//                     >
//                       <ListItemAvatar sx={{ minWidth: 36 }}>
//                         <Avatar sx={{
//                           width: 24,
//                           height: 24,
//                           bgcolor: getStatusColor(activity.to_status) + '.main',
//                           color: 'white',
//                           fontSize: '0.85rem'
//                         }}>
//                           {getStatusIcon(activity.to_status)}
//                         </Avatar>
//                       </ListItemAvatar>
//                       <ListItemText
//                         sx={{ m: 0 }}
//                         primary={
//                           <Box>
//                             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
//                               <Box>
//                                 {activity.from_status ? (
//                                   <Typography variant="body2" fontWeight="medium" sx={{ fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                                     {getStatusIconBall(activity.from_status)} {activity.from_status} →  {getStatusIconBall(activity.to_status)} {activity.to_status}
//                                   </Typography>
//                                 ) : (
//                                   <Typography variant="body2" fontWeight="medium" sx={{ fontSize: '0.85rem' }}>
//                                     Enquiry created as {getStatusIconBall(activity.to_status)  } {activity.to_status} 
//                                   </Typography>
//                                 )}
//                               </Box>
//                               <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
//                                 {formatDateTime(activity.changed_at)}
//                               </Typography>
//                             </Box>

//                             {/* Show note if exists */}
//                             {(activity.note || enquiry?.status_notes[0]?.note) && (
//                               <Paper elevation={0} sx={{
//                                 py: 0,
//                                 px: 1,
//                                 mt: 1,
//                                 bgcolor: 'background.default',
//                                 border: '1px solid',
//                                 borderColor: 'divider',
//                                 borderRadius: 0.5
//                               }}>
//                                 <Typography variant="caption" sx={{ fontSize: '0.8rem' }}>
//                                   {activity.note ? activity.note : enquiry?.status_notes[0]?.note || ''}
//                                 </Typography>
//                               </Paper>
//                             )}
//                           </Box>
//                         }
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               ) : (
//                 <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
//                   No activity history available
//                 </Typography>
//               )}
//             </Card>
//           </Box>

//           {/* RIGHT COLUMN */}
//           <Box sx={{ flex: 1 }}>
//             {/* Party Information */}
//             <Card elevation={0} sx={{
//               borderRadius: 1,
//               mb: 1,
//               border: '1px solid',
//               borderColor: 'divider',
//               p: 2
//             }}>
//               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <BusinessIcon fontSize="small" />
//                 {party ? 'Party Details' : 'Walk-in Customer'}
//               </Typography>

//               {party ? (
//                 <Stack spacing={2} >
//                   <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
//                     <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
//                       <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                         Party Name
//                       </Typography>
//                       <Typography variant="body1" fontWeight="medium">
//                         {party.partyName}
//                         {party.nickName && (
//                           <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                             ({party.nickName})
//                           </Typography>
//                         )}
//                       </Typography>
//                     </Box>

//                     {party.entityCategory && (
//                       <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
//                         <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                           Type
//                         </Typography>
//                         <Chip
//                           label={party.entityCategory}
//                           size="small"
//                           sx={{ fontSize: '0.75rem' }}
//                         />
//                       </Box>
//                     )}
//                   </Box>

//                   <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
//                     {party.contact.phone.length > 0 && (
//                       <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
//                         <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                           Contact
//                         </Typography>
//                         <Stack spacing={1}>
//                           {party.contact.phone.map((phone, index) => (
//                             <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                               <PhoneIcon fontSize="small" color="action" />
//                               <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
//                                 {phone.phoneNo}
//                                 {phone.label && (
//                                   <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                                     ({phone.label})
//                                   </Typography>
//                                 )}
//                               </Typography>
//                             </Box>
//                           ))}
//                         </Stack>
//                       </Box>
//                     )}

//                     {party.location && (
//                       <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
//                         <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                           Location
//                         </Typography>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <LocationIcon fontSize="small" color="action" />
//                           <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
//                             {party.location}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     )}
//                   </Box>

//                 </Stack>
//               ) : (
//                 <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
//                   Walk-in customer enquiry
//                 </Typography>
//               )}
//             </Card>

//             {/* Employee Information */}
//             <Card elevation={0} sx={{
//               borderRadius: 1,
//               mb: 1,
//               border: '1px solid',
//               borderColor: 'divider',
//               p: 2
//             }}>
//               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <PersonIcon fontSize="small" />
//                 Assigned Employee
//               </Typography>

//               {employee ? (
//                 <Stack spacing={2}>
//                   <Box>
//                     <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                       Employee Name
//                     </Typography>
//                     <Typography variant="body1" fontWeight="medium">
//                       {employee.first_name} {employee.last_name}
//                     </Typography>
//                   </Box>

//                   {employee.contact.phone.length > 0 && (
//                     <Box>
//                       <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                         Contact
//                       </Typography>
//                       <Stack spacing={1}>
//                         {employee.contact.phone.map((phone, index) => (
//                           <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <PhoneIcon fontSize="small" color="action" />
//                             <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
//                               {phone.phone_no}
//                               {phone.label && (
//                                 <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                                   ({phone.label})
//                                 </Typography>
//                               )}
//                             </Typography>
//                           </Box>
//                         ))}
//                       </Stack>
//                     </Box>
//                   )}
//                 </Stack>
//               ) : (
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
//                     No employee assigned
//                   </Typography>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     startIcon={<PersonIcon />}
//                     onClick={() => navigate(`/enquiry/editEnquiry/${id}`)}
//                   >
//                     Assign Employee
//                   </Button>
//                 </Box>
//               )}
//             </Card>

//             {/* Products Section */}
//             <Card elevation={0} sx={{
//               borderRadius: 1,
//               mb: 1,
//               border: '1px solid',
//               borderColor: 'divider',
//               p: 2
//             }}>
//               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <InventoryIcon fontSize="small" />
//                 Products ({products.length})
//               </Typography>

//               {products.length > 0 ? (
//                 <Stack spacing={1.5}>
//                   {products.map((product) => (
//                     <Paper
//                       key={product._id}
//                       elevation={0}
//                       sx={{
//                         p: 1.5,
//                         bgcolor: 'background.default',
//                         border: '1px solid',
//                         borderColor: 'divider',
//                         borderRadius: 0.5
//                       }}
//                     >
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Box>
//                           <Typography variant="body2" fontWeight="medium">
//                             {product.name}
//                           </Typography>
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
//                             <TagIcon fontSize="small" color="action" sx={{ fontSize: '0.75rem' }} />
//                             <Typography variant="caption" color="text.secondary">
//                               HSN: {product.partNo || 'N/A'}
//                             </Typography>
//                           </Box>
//                         </Box>
//                         <Tooltip title="View Product Details" placement='top' arrow>
//                           <IconButton
//                             size="small"
//                             onClick={() => navigate(`/inventory/${product._id}`)}
//                           >
//                             <LaunchIcon fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       </Box>
//                     </Paper>
//                   ))}
//                 </Stack>
//               ) : (
//                 <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
//                   No products selected
//                 </Typography>
//               )}
//             </Card>

//             {/* Metadata */}
//             <Card elevation={0} sx={{
//               borderRadius: 1,
//               border: '1px solid',
//               borderColor: 'divider',
//               p: 2
//             }}>
//               <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <CalendarIcon fontSize="small" />
//                 Metadata
//               </Typography>

//               <Stack spacing={1.5}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Enquiry No
//                   </Typography>
//                   <Typography variant="body2" fontWeight="medium">
//                     {enquiry.enquiry_no}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Created Date
//                   </Typography>
//                   <Typography variant="body2" fontWeight="medium">
//                     {formatDate(enquiry.enquiry_date)}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Last Updated
//                   </Typography>
//                   <Typography variant="body2" fontWeight="medium">
//                     {formatDate(enquiry.updatedAt || enquiry.created_at)}
//                   </Typography>
//                 </Box>

//                 {enquiry.created_at && (
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                     <Typography variant="body2" color="text.secondary">
//                       System Created
//                     </Typography>
//                     <Typography variant="body2" fontWeight="medium">
//                       {formatDate(enquiry.created_at)}
//                     </Typography>
//                   </Box>
//                 )}
//               </Stack>
//             </Card>
//           </Box>
//         </Box>
//       </Box>

//       {/* Status Change Dialog */}
//       <Dialog open={statusDialogOpen} onClose={() => setStatusDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 2 }}>
//           <SyncAltIcon fontSize="small" />
//           <Typography variant="subtitle1" fontWeight="bold">
//             Update Status
//           </Typography>
//         </DialogTitle>
//         <DialogContent sx={{ py: 2 }}>
//           <Stack spacing={2}>
//             <Box>
//               <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                 Current Status
//               </Typography>
//               <Chip
//                 label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                   {getStatusIconBall(enquiry?.status)}
//                   <Typography variant="caption" sx={{ fontWeight: 500 }}>
//                     {enquiry?.status}
//                   </Typography>
//                 </Box>}
//                 color={getStatusColor(enquiry?.status) as any}
//                 size="small"
//                 sx={{ fontSize: '0.75rem' }}
//               />
//             </Box>

//             <FormControl fullWidth size="small">
//               <InputLabel>New Status *</InputLabel>
//               <Select
//                 value={newStatus}
//                 label="New Status *"
//                 onChange={(e) => setNewStatus(e.target.value)}
//               >
//                 <MenuItem value="NEW">🟢 New</MenuItem>
//                 <MenuItem value="ASSIGNED">🔵 Assigned</MenuItem>
//                 <MenuItem value="IN_PROGRESS">🟡 In Progress</MenuItem>
//                 <MenuItem value="FOLLOW_UP">🟠 Follow Up</MenuItem>
//                 <MenuItem value="CONVERTED">🟣 Converted</MenuItem>
//                 <MenuItem value="CLOSED">⚫ Closed</MenuItem>
//                 <MenuItem value="CANCELLED">🔴 Cancelled</MenuItem>
//               </Select>
//             </FormControl>

//             <TextField
//               fullWidth
//               multiline
//               rows={2}
//               size="small"
//               label="Status Note *"
//               placeholder="Explain why you're changing the status..."
//               value={statusNote}
//               onChange={(e) => setStatusNote(e.target.value)}
//               helperText="This note will be shown in the activity timeline"
//               required
//             />
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, pt: 0 }}>
//           <Button
//             onClick={() => setStatusDialogOpen(false)}
//             disabled={changingStatus}
//             size="small"
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleStatusChange}
//             disabled={!newStatus || !statusNote.trim() || changingStatus || newStatus === enquiry?.status}
//             size="small"
//             sx={{ fontSize: '0.75rem' }}
//           >
//             {changingStatus ? 'Updating...' : 'Update Status'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default ShowEnquiry;


// ========================================== New ---------
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Paper,
  IconButton,
  CircularProgress,
  Alert,
  Tooltip,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  alpha,
  ImageList,
  ImageListItem,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  Description as DescriptionIcon,
  PriorityHigh as PriorityHighIcon,
  LocalPhone as PhoneIcon,
  LocationOn as LocationIcon,
  Inventory as InventoryIcon,
  Launch as LaunchIcon,
  CalendarToday as CalendarIcon,
  History as HistoryIcon,
  SyncAlt as SyncAltIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Assignment as AssignmentIcon,
  Schedule as ScheduleIcon,
  Source as SourceIcon,
  Notes as NotesIcon,
  Tag as TagIcon,
  Image as ImageIcon,
  Close as CloseIcon,
  ZoomIn as ZoomInIcon,
} from '@mui/icons-material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { format } from 'date-fns';
import Brandcrumb from '../../../../componentsUiBlock/Brandcrumb';
import { request } from '../../../../utils/request';
import { ApiResponseSingleEnquiry, Employee, Enquiry, Party, Product, StatusActivity } from '../../types';
import { toast } from 'react-toastify';
import { getStatusIconBall } from '../ListEnquiry';
import { baseUrlImage } from '../../../../utils/apiClient';

const ShowEnquiry = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [enquiry, setEnquiry] = useState<Enquiry | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [party, setParty] = useState<Party | null>(null);
  const [employee, setEmployee] = useState<Employee | null>(null);
  const [products, setProducts] = useState<Product[]>([]);
  const [statusHistory, setStatusHistory] = useState<StatusActivity[]>([]);
  const [enquiryImages, setEnquiryImages] = useState<string[]>([]);

  // Image gallery modal state
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);

  // Status change dialog
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [newStatus, setNewStatus] = useState<string>('');
  const [statusNote, setStatusNote] = useState<string>('');
  const [changingStatus, setChangingStatus] = useState(false);

  // Helper function to parse enquiry images
  const parseEnquiryImages = (images: any): string[] => {
    if (!images) return [];

    // If it's already an array, return it
    if (Array.isArray(images)) {
      return images;
    }

    // If it's a string, try to parse it as JSON
    if (typeof images === 'string') {
      try {
        const parsed = JSON.parse(images);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (e) {
        // If parsing fails, treat it as a single image URL
        console.warn('Failed to parse enquiryImages as JSON, treating as single URL:', e);
        return [images];
      }
    }

    return [];
  };

  const fetchEnquiry = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    try {
      const response = await request({
        url: `enquiry/get-single-enquiry/${id}`,
        method: 'get',
      }) as ApiResponseSingleEnquiry;

      if (response.success && response.data) {
        const enquiryData = response.data;
        setEnquiry(enquiryData);
        setParty(enquiryData.party || null);
        setEmployee(enquiryData.assigned_employee || null);
        setProducts(enquiryData.products || []);

        // Parse enquiry images (handle both array and stringified JSON)
        const parsedImages = parseEnquiryImages(enquiryData.enquiryImages);
        console.log('Parsed enquiry images:', parsedImages); // Debug log
        setEnquiryImages(parsedImages);

        // Set status history
        let history = enquiryData.status_history || [];
        if (history.length === 0 && enquiryData.status) {
          history = [{
            from_status: undefined,
            to_status: enquiryData.status,
            note: enquiryData.status_note || '',
            changed_at: enquiryData.status_changed_at || enquiryData.created_at || new Date(),
            is_initial: true,
            created_at: undefined
          }];
        }
        setStatusHistory(history);
      } else {
        setError('Enquiry not found');
      }
    } catch (err: any) {
      console.error('Error fetching enquiry:', err);
      setError(err.message || 'Failed to load enquiry details');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchEnquiry();
  }, [fetchEnquiry]);

  const getStatusColor = (status?: string) => {
    switch (status) {
      case 'NEW': return 'success';
      case 'ASSIGNED': return 'info';
      case 'IN_PROGRESS': return 'primary';
      case 'FOLLOW_UP': return 'warning';
      case 'CONVERTED': return 'secondary';
      case 'CLOSED': return 'default';
      case 'CANCELLED': return 'error';
      default: return 'default';
    }
  };

  const getStatusIcon = (status?: string) => {
    switch (status) {
      case 'NEW': return <CheckCircleIcon fontSize="small" />;
      case 'ASSIGNED': return <AssignmentIcon fontSize="small" />;
      case 'IN_PROGRESS': return <SyncAltIcon fontSize="small" />;
      case 'FOLLOW_UP': return <ScheduleIcon fontSize="small" />;
      case 'CONVERTED': return <CheckCircleIcon fontSize="small" />;
      case 'CLOSED': return <CheckCircleIcon fontSize="small" />;
      case 'CANCELLED': return <CancelIcon fontSize="small" />;
      default: return <CheckCircleIcon fontSize="small" />;
    }
  };

  const getPriorityIcon = (priority?: string) => {
    switch (priority) {
      case 'HIGH': return <PriorityHighIcon color="error" fontSize="small" />;
      case 'MEDIUM': return <PriorityHighIcon color="warning" fontSize="small" />;
      case 'LOW': return <PriorityHighIcon color="success" fontSize="small" />;
      default: return <PriorityHighIcon color="disabled" fontSize="small" />;
    }
  };

  const formatDateTime = (date: any) => {
    if (!date) return 'N/A';
    try {
      return format(new Date(date), 'dd MMM yyyy, HH:mm');
    } catch {
      return 'Invalid date';
    }
  };

  const formatDate = (date: any) => {
    if (!date) return 'N/A';
    try {
      return format(new Date(date), 'dd/MM/yyyy');
    } catch {
      return 'Invalid date';
    }
  };

  // Helper function to get full image URL
  const getFullImageUrl = (imagePath: string): string => {
    // If it already starts with http, return as is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    // Otherwise prepend baseUrlImage
    return baseUrlImage + imagePath;
  };

  const handleStatusChange = async () => {
    if (!newStatus || !enquiry || newStatus === enquiry.status) return;

    setChangingStatus(true);
    try {
      const payload: any = {
        status: newStatus,
        status_note: statusNote.trim()
      };

      // Add status-specific fields if needed
      if (newStatus === 'CLOSED') {
        if (!enquiry.closed_result && !statusNote.trim()) {
          toast.error('Please provide a closing reason');
          setChangingStatus(false);
          return;
        }
        payload.closed_result = statusNote.trim() || enquiry.closed_result || 'No reason provided';
      } else if (newStatus === 'CANCELLED') {
        if (!enquiry.cancelled_reason && !statusNote.trim()) {
          toast.error('Please provide a cancellation reason');
          setChangingStatus(false);
          return;
        }
        payload.cancelled_reason = statusNote.trim() || enquiry.cancelled_reason || 'No reason provided';
      }

      const res = await request({
        url: `enquiry/update-enquiry/${id}`,
        method: 'put',
        data: payload,
      });

      if (res.success) {
        toast.success('Status updated successfully!');
        setStatusDialogOpen(false);
        setNewStatus('');
        setStatusNote('');
        fetchEnquiry(); // Refresh the data
      } else {
        toast.error(res.message || 'Failed to update status');
      }
    } catch (err: any) {
      console.error('Status change error:', err);
      toast.error(err || 'Failed to update status');
    } finally {
      setChangingStatus(false);
    }
  };

  const openStatusDialog = () => {
    if (enquiry) {
      setNewStatus(enquiry.status ?? '');
      setStatusNote('');
      setStatusDialogOpen(true);
    }
  };

  // Image gallery handlers
  const openImageModal = (imageUrl: string, index: number) => {
    setSelectedImage(imageUrl);
    setSelectedImageIndex(index);
    setImageModalOpen(true);
  };

  const closeImageModal = () => {
    setImageModalOpen(false);
    setSelectedImage(null);
  };

  const nextImage = () => {
    if (selectedImageIndex < enquiryImages.length - 1) {
      const nextIndex = selectedImageIndex + 1;
      setSelectedImageIndex(nextIndex);
      setSelectedImage(enquiryImages[nextIndex]);
    }
  };

  const prevImage = () => {
    if (selectedImageIndex > 0) {
      const prevIndex = selectedImageIndex - 1;
      setSelectedImageIndex(prevIndex);
      setSelectedImage(enquiryImages[prevIndex]);
    }
  };

  // Get activity timeline
  const getActivityTimeline = () => {
    const timeline = [...statusHistory];

    // Sort by date (newest first)
    timeline.sort((a, b) => {
      const dateA = new Date(a.changed_at || 0);
      const dateB = new Date(b.changed_at || 0);
      return dateB.getTime() - dateA.getTime();
    });

    return timeline;
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
        <CircularProgress size={24} />
        <Typography variant="body2" sx={{ ml: 2, color: 'text.secondary' }}>
          Loading enquiry details...
        </Typography>
      </Box>
    );
  }

  if (error || !enquiry) {
    return (
      <Box sx={{ p: 2 }}>
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
          <Brandcrumb />
        </Box>
        <Card>
          <CardContent>
            <Alert severity="error" sx={{ mb: 2 }}>
              {error || 'Enquiry not found'}
            </Alert>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/enquiry')}
              size="small"
            >
              Back to Enquiries
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  const activityTimeline = getActivityTimeline();

  return (
    <>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
        <Brandcrumb />
        <Chip
          onClick={() => navigate(-1)}
          icon={<ArrowBackIosNewIcon sx={{ fontSize: "14px" }} />}
          label="Back"
          variant="filled"
          color="secondary"
          sx={{
            fontSize: '14px',
            color: 'text.secondary',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'action.hover'
            }
          }}
        />
      </Box>

      <Box sx={{ mb: 3 }}>
        {/* Header */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
          p: 2,
          backgroundColor: 'white',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton
              onClick={() => navigate('/enquiry')}
              size="small"
              sx={{ color: 'text.primary' }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <Typography variant="h6" fontWeight="bold">
                {enquiry.subject}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {enquiry.enquiry_no}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Tooltip title="Edit Enquiry" placement='top' arrow>
              <IconButton
                size="small"
                color="primary"
                onClick={() => navigate(`/enquiry/editEnquiry/${id}`)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Two Column Layout with Equal Width */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 2 }}>

          {/* LEFT COLUMN */}
          <Box sx={{ flex: 1 }}>
            {/* Top Row: Assigned Date on Left, Status on Right */}
            <Box sx={{ display: 'flex', mb: 1, gap: 1 }}>
              {/* Assigned Date Card */}
              <Card elevation={0} sx={{
                flex: 1,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'center',
                p: 2,
                py: 1
              }}>
                <CalendarIcon fontSize="small" color="action" sx={{ mr: 1.5 }} />
                <Box>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Assigned Date
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {enquiry.assigned_date ? formatDate(enquiry.assigned_date) : 'Not assigned'}
                  </Typography>
                </Box>
              </Card>

              {/* Status Card with Change Button */}
              <Card elevation={0} sx={{
                flex: 1,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                p: 2,
                py: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {getStatusIcon(enquiry.status)}
                  <Box sx={{ ml: 1.5 }}>
                    <Stack direction={'row'} spacing={6}>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Current Status
                      </Typography>
                    </Stack>

                    <Stack direction={'row'} spacing={.5} alignItems={"center"}>
                      <Chip
                        label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          {getStatusIconBall(enquiry.status)}
                          <Typography variant="caption" sx={{ fontWeight: 500 }}>
                            {enquiry.status}
                          </Typography>
                        </Box>}
                        color={getStatusColor(enquiry.status) as any}
                        size="small"
                        sx={{ height: 22, fontSize: '0.75rem', mt: 0.5 }}
                      />
                      <Tooltip title="Update Status" arrow placement='top'>
                        <IconButton size="small" color="primary" onClick={openStatusDialog}>
                          <SyncAltIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                </Box>
              </Card>
            </Box>

            {/* Second Row: Priority on Left, Source on Right */}
            <Box sx={{ display: 'flex', mb: 1, gap: 1 }}>
              {/* Priority Card */}
              <Card elevation={0} sx={{
                flex: 1,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'center',
                p: 2,
                py: 1
              }}>
                {getPriorityIcon(enquiry.priority)}
                <Box sx={{ ml: 1.5 }}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Priority
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {enquiry.priority}
                  </Typography>
                </Box>
              </Card>

              {/* Source Card */}
              <Card elevation={0} sx={{
                flex: 1,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'center',
                p: 2,
                py: 1
              }}>
                <SourceIcon fontSize="small" color="action" sx={{ mr: 1.5 }} />
                <Box>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Source
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {enquiry.source}
                  </Typography>
                </Box>
              </Card>
            </Box>

            {/* Subject Section */}
            <Card elevation={0} sx={{
              borderRadius: 1,
              mb: 1,
              border: '1px solid',
              borderColor: 'divider',
              p: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                <DescriptionIcon fontSize="small" />
                Subject
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {enquiry.subject}
              </Typography>
            </Card>

            {/* Description Section */}
            <Card elevation={0} sx={{
              borderRadius: 1,
              mb: 1,
              border: '1px solid',
              borderColor: 'divider',
              p: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                <NotesIcon fontSize="small" />
                Description
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line', fontSize: '0.9rem' }}>
                {enquiry.description}
              </Typography>
            </Card>

            {/* Status-specific information */}
            {(enquiry.status === 'CLOSED' && enquiry.closed_result) && (
              <Card elevation={0} sx={{
                borderRadius: 1,
                mb: 1,
                border: '1px solid',
                borderColor: 'divider',
                p: 2,
                bgcolor: alpha('#4caf50', 0.08)
              }}>
                <Typography variant="subtitle2" fontWeight="bold" color="success.main" sx={{ mb: 1 }}>
                  Closed Result
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                  {enquiry.closed_result}
                </Typography>
              </Card>
            )}

            {(enquiry.status === 'CANCELLED' && enquiry.cancelled_reason) && (
              <Card elevation={0} sx={{
                borderRadius: 1,
                mb: 1,
                border: '1px solid',
                borderColor: 'divider',
                p: 2,
                bgcolor: alpha('#f44336', 0.08)
              }}>
                <Typography variant="subtitle2" fontWeight="bold" color="error.main" sx={{ mb: 1 }}>
                  Cancellation Reason
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                  {enquiry.cancelled_reason}
                </Typography>
              </Card>
            )}

            {/* Activity Timeline */}
            <Card elevation={0} sx={{
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
              p: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <HistoryIcon fontSize="small" />
                Activity Timeline
              </Typography>

              {activityTimeline.length > 0 ? (
                <List sx={{
                  position: 'relative',
                  '&:before': {
                    content: '""',
                    position: 'absolute',
                    left: 12,
                    top: 5,
                    bottom: 0,
                    width: 2,
                    backgroundColor: 'divider'
                  },
                  py: 0
                }}>
                  {activityTimeline.map((activity, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        position: 'relative',
                        alignItems: 'flex-start',
                        py: 1.5,
                        px: 0,
                        '&:last-child': {
                          pb: 0
                        }
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 36 }}>
                        <Avatar sx={{
                          width: 24,
                          height: 24,
                          bgcolor: getStatusColor(activity.to_status) + '.main',
                          color: 'white',
                          fontSize: '0.85rem'
                        }}>
                          {getStatusIcon(activity.to_status)}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ m: 0 }}
                        primary={
                          <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
                              <Box>
                                {activity.from_status ? (
                                  <Typography variant="body2" fontWeight="medium" sx={{ fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    {getStatusIconBall(activity.from_status)} {activity.from_status} →  {getStatusIconBall(activity.to_status)} {activity.to_status}
                                  </Typography>
                                ) : (
                                  <Typography variant="body2" fontWeight="medium" sx={{ fontSize: '0.85rem' }}>
                                    Enquiry created as {getStatusIconBall(activity.to_status)} {activity.to_status}
                                  </Typography>
                                )}
                              </Box>
                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                {formatDateTime(activity.changed_at)}
                              </Typography>
                            </Box>

                            {/* Show note if exists */}
                            {(activity.note || enquiry?.status_notes?.[0]?.note) && (
                              <Paper elevation={0} sx={{
                                py: 0,
                                px: 1,
                                mt: 1,
                                bgcolor: 'background.default',
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 0.5
                              }}>
                                <Typography variant="caption" sx={{ fontSize: '0.8rem' }}>
                                  {activity.note ? activity.note : enquiry?.status_notes?.[0]?.note || ''}
                                </Typography>
                              </Paper>
                            )}
                          </Box>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                  No activity history available
                </Typography>
              )}
            </Card>
          </Box>

          {/* RIGHT COLUMN */}
          <Box sx={{ flex: 1 }}>
            {/* Images Section */}
            {enquiryImages.length > 0 && (
              <Card elevation={0} sx={{
                borderRadius: 1,
                mb: 1,
                border: '1px solid',
                borderColor: 'divider',
                p: 2
              }}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ImageIcon fontSize="small" />
                  Enquiry Images ({enquiryImages.length})
                </Typography>

                <ImageList cols={3} gap={8} sx={{ m: 0 }}>
                  {enquiryImages.map((image, index) => {
                    const fullImageUrl = getFullImageUrl(image);
                    console.log(`Image ${index} URL:`, fullImageUrl); // Debug log
                    return (
                      <ImageListItem key={index} sx={{ cursor: 'pointer' }}>
                        <Avatar
                          variant="rounded"
                          src={fullImageUrl}
                          sx={{
                            width: '100%',
                            height: 100,
                            borderRadius: 1,
                            cursor: 'pointer',
                            transition: 'transform 0.2s',
                            '&:hover': {
                              transform: 'scale(1.05)',
                            }
                          }}
                          onClick={() => openImageModal(image, index)}
                        />
                      </ImageListItem>
                    );
                  })}
                </ImageList>

                {/* Image Count and View All Button */}
                {enquiryImages.length > 3 && (
                  <Box sx={{ mt: 1, textAlign: 'center' }}>
                    <Button
                      size="small"
                      startIcon={<ZoomInIcon />}
                      onClick={() => openImageModal(enquiryImages[0], 0)}
                    >
                      View All {enquiryImages.length} Images
                    </Button>
                  </Box>
                )}
              </Card>
            )}

            {/* Party Information */}
            <Card elevation={0} sx={{
              borderRadius: 1,
              mb: 1,
              border: '1px solid',
              borderColor: 'divider',
              p: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <BusinessIcon fontSize="small" />
                {party ? 'Party Details' : 'Walk-in Customer'}
              </Typography>

              {party ? (
                <Stack spacing={2}>
                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                        Party Name
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {party.partyName}
                        {party.nickName && (
                          <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                            ({party.nickName})
                          </Typography>
                        )}
                      </Typography>
                    </Box>

                    {party.entityCategory && (
                      <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                          Type
                        </Typography>
                        <Chip
                          label={party.entityCategory}
                          size="small"
                          sx={{ fontSize: '0.75rem' }}
                        />
                      </Box>
                    )}
                  </Box>

                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    {party.contact.phone.length > 0 && (
                      <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                          Contact
                        </Typography>
                        <Stack spacing={1}>
                          {party.contact.phone.map((phone, index) => (
                            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <PhoneIcon fontSize="small" color="action" />
                              <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                                {phone.phoneNo}
                                {phone.label && (
                                  <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                    ({phone.label})
                                  </Typography>
                                )}
                              </Typography>
                            </Box>
                          ))}
                        </Stack>
                      </Box>
                    )}

                    {party.location && (
                      <Box display={'flex'} flexDirection={'column'} alignItems={'start'} justifyContent={'start'} width={'50%'}>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                          Location
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <LocationIcon fontSize="small" color="action" />
                          <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                            {party.location}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Stack>
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                  Walk-in customer enquiry
                </Typography>
              )}
            </Card>

            {/* Employee Information */}
            <Card elevation={0} sx={{
              borderRadius: 1,
              mb: 1,
              border: '1px solid',
              borderColor: 'divider',
              p: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon fontSize="small" />
                Assigned Employee
              </Typography>

              {employee ? (
                <Stack spacing={2}>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                      Employee Name
                    </Typography>
                    <Typography variant="body1" fontWeight="medium">
                      {employee.first_name} {employee.last_name}
                    </Typography>
                  </Box>

                  {employee.contact.phone.length > 0 && (
                    <Box>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                        Contact
                      </Typography>
                      <Stack spacing={1}>
                        {employee.contact.phone.map((phone, index) => (
                          <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <PhoneIcon fontSize="small" color="action" />
                            <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                              {phone.phone_no}
                              {phone.label && (
                                <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                  ({phone.label})
                                </Typography>
                              )}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  )}
                </Stack>
              ) : (
                <Box>
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
                    No employee assigned
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<PersonIcon />}
                    onClick={() => navigate(`/enquiry/editEnquiry/${id}`)}
                  >
                    Assign Employee
                  </Button>
                </Box>
              )}
            </Card>

            {/* Products Section */}
            <Card elevation={0} sx={{
              borderRadius: 1,
              mb: 1,
              border: '1px solid',
              borderColor: 'divider',
              p: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <InventoryIcon fontSize="small" />
                Products ({products.length})
              </Typography>

              {products.length > 0 ? (
                <Stack spacing={1.5}>
                  {products.map((product) => (
                    <Paper
                      key={product._id}
                      elevation={0}
                      sx={{
                        p: 1.5,
                        bgcolor: 'background.default',
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 0.5
                      }}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                          <Typography variant="body2" fontWeight="medium">
                            {product.name}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                            <TagIcon fontSize="small" color="action" sx={{ fontSize: '0.75rem' }} />
                            <Typography variant="caption" color="text.secondary">
                              HSN: {product.partNo || 'N/A'}
                            </Typography>
                          </Box>
                        </Box>
                        <Tooltip title="View Product Details" placement='top' arrow>
                          <IconButton
                            size="small"
                            onClick={() => navigate(`/inventory/${product._id}`)}
                          >
                            <LaunchIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Paper>
                  ))}
                </Stack>
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                  No products selected
                </Typography>
              )}
            </Card>

            {/* Metadata */}
            <Card elevation={0} sx={{
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
              p: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <CalendarIcon fontSize="small" />
                Metadata
              </Typography>

              <Stack spacing={1.5}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2" color="text.secondary">
                    Enquiry No
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {enquiry.enquiry_no}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2" color="text.secondary">
                    Created Date
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {formatDate(enquiry.enquiry_date)}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2" color="text.secondary">
                    Last Updated
                  </Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {formatDate(enquiry.updatedAt || enquiry.created_at)}
                  </Typography>
                </Box>

                {enquiry.created_at && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary">
                      System Created
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {formatDate(enquiry.created_at)}
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Card>
          </Box>
        </Box>
      </Box>

      {/* Image Gallery Modal */}
      <Dialog
        open={imageModalOpen}
        onClose={closeImageModal}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: 'rgba(0, 0, 0, 0.9)',
            position: 'relative',
          }
        }}
      >
        <DialogContent sx={{ p: 0, position: 'relative', minHeight: '60vh' }}>
          <IconButton
            onClick={closeImageModal}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              zIndex: 1,
              bgcolor: 'rgba(0,0,0,0.5)',
              color: 'white',
              '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
            }}
          >
            <CloseIcon />
          </IconButton>

          {selectedImage && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                position: 'relative'
              }}
            >
              {/* Previous Button */}
              {enquiryImages.length > 1 && (
                <IconButton
                  onClick={prevImage}
                  disabled={selectedImageIndex === 0}
                  sx={{
                    position: 'absolute',
                    left: 10,
                    zIndex: 1,
                    bgcolor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
                    '&.Mui-disabled': { opacity: 0.3 }
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>
              )}

              <img
                src={getFullImageUrl(selectedImage)}
                alt="Enquiry"
                style={{
                  maxWidth: '100%',
                  maxHeight: '70vh',
                  objectFit: 'contain',
                }}
                onError={(e) => {
                  console.error('Failed to load image:', getFullImageUrl(selectedImage));
                  e.currentTarget.style.display = 'none';
                }}
              />

              {/* Next Button */}
              {enquiryImages.length > 1 && (
                <IconButton
                  onClick={nextImage}
                  disabled={selectedImageIndex === enquiryImages.length - 1}
                  sx={{
                    position: 'absolute',
                    right: 10,
                    zIndex: 1,
                    bgcolor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
                    '&.Mui-disabled': { opacity: 0.3 }
                  }}
                >
                  <ArrowBackIcon sx={{ transform: 'rotate(180deg)' }} />
                </IconButton>
              )}
            </Box>
          )}
        </DialogContent>
        <Box sx={{ p: 2, bgcolor: 'rgba(0,0,0,0.8)', color: 'white', textAlign: 'center' }}>
          <Typography variant="body2">
            Image {selectedImageIndex + 1} of {enquiryImages.length}
          </Typography>
        </Box>
      </Dialog>

      {/* Status Change Dialog */}
      <Dialog open={statusDialogOpen} onClose={() => setStatusDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 2 }}>
          <SyncAltIcon fontSize="small" />
          <Typography variant="subtitle1" fontWeight="bold">
            Update Status
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ py: 2 }}>
          <Stack spacing={2}>
            <Box>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                Current Status
              </Typography>
              <Chip
                label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  {getStatusIconBall(enquiry?.status)}
                  <Typography variant="caption" sx={{ fontWeight: 500 }}>
                    {enquiry?.status}
                  </Typography>
                </Box>}
                color={getStatusColor(enquiry?.status) as any}
                size="small"
                sx={{ fontSize: '0.75rem' }}
              />
            </Box>

            <FormControl fullWidth size="small">
              <InputLabel>New Status *</InputLabel>
              <Select
                value={newStatus}
                label="New Status *"
                onChange={(e) => setNewStatus(e.target.value)}
              >
                <MenuItem value="NEW">🟢 New</MenuItem>
                <MenuItem value="ASSIGNED">🔵 Assigned</MenuItem>
                <MenuItem value="IN_PROGRESS">🟡 In Progress</MenuItem>
                <MenuItem value="FOLLOW_UP">🟠 Follow Up</MenuItem>
                <MenuItem value="CONVERTED">🟣 Converted</MenuItem>
                <MenuItem value="CLOSED">⚫ Closed</MenuItem>
                <MenuItem value="CANCELLED">🔴 Cancelled</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              multiline
              rows={2}
              size="small"
              label="Status Note *"
              placeholder="Explain why you're changing the status..."
              value={statusNote}
              onChange={(e) => setStatusNote(e.target.value)}
              helperText="This note will be shown in the activity timeline"
              required
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={() => setStatusDialogOpen(false)}
            disabled={changingStatus}
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleStatusChange}
            disabled={!newStatus || !statusNote.trim() || changingStatus || newStatus === enquiry?.status}
            size="small"
            sx={{ fontSize: '0.75rem' }}
          >
            {changingStatus ? 'Updating...' : 'Update Status'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShowEnquiry;